import React from "react";
import SectionTitle from "../Templates/Text/SectionTitle";

export default function About() {
  return (
    <div className="container-fluid">
      <div className="row p-30-0">
        {/* header */}
        <SectionTitle
          title="About Me"
          rightTitle="Fri Mar 19, 2021"
          rightClass="art-project-category"
        />

        {/* content */}
        <div className="col-lg-12">
          <div className="art-a art-card">
            {/* <p className="art-lg-text art-white">
              <i>
                Consectetur adipisicing elit. Magni debitis nemo, minus aut
                tempora impedit quis quam omnis, odit saepe ipsa sunt magnam
                culpa quisquam iusto consectetur necessitatibus. Tenetur,
                eligendi!
              </i>
            </p> */}

            <p>
              With over 2+ years of dedicated experience in web design and
              development, Having hands-on experience in identifying web-based
              user interactions and designing and implementing highly responsive
              user interface components by deploying React concepts. Proficient
              in translating designs and wireframes into high-quality code and
              writing application interface code via JavaScript and React.js
              workflows. I bring a wealth of expertise to craft exceptional
              digital solutions. Proficient in both front-end and back-end
              development, I am dedicated to delivering results that exceed
              expectations. I have developed several web applications from
              scratch but at the same time, I manage and update the client’s
              existing projects also as I have outstanding debugging skills.
            </p>
            <p>
              I'm very proficient in working with the following technologies:
            </p>
            <ul className="art-custom-list">
              <li>React JS</li>
              <li>Typescript </li>
              <li>GraphQL</li>
              <li>JavaScript</li>
              <li>Express.js</li>
              <li>React Native</li>
              <li>Rest APIs</li>
              <li>Test Driver Development</li>
              <li>Node.js</li>
            </ul>
            <p>
              I have been creating JavaScript apps for the last 2+ years: my
              main focus is web development using React.js, Next.js, and
              Node.js, I have a strong background in front-end design and
              development, and happily work in SASS, HTML5, JavaScript, and
              React to create websites that work beautifully for everyone.
            </p>
            <p>
              <h5
                style={{
                  borderBottom: "1px solid #ffc107",
                  paddingBottom: "5px",
                  marginBottom: "5px",
                  width: "fit-content",
                }}
              >
                Summary
              </h5>
            </p>
            <p>
              <ul>
                <li>
                  Extensive experience in developing web pages using HTML/HTML5,
                  CSS/CSS3, SASS, LESS, Bootstrap, Tailwind, JavaScript,
                  TypeScript, React JS, Redux, Flexbox, StyledComponent, JSON.
                </li>
                <li>
                  Experienced in React JS and working with the React Redux,
                  Redux-toolkit, Redux-Saga and React Hooks architectures.
                </li>
                <li>
                  Excellent working knowledge and thorough exposure to
                  compatibility issues with different versions of browsers like
                  IE, Mozilla Firefox, Safari, and Chrome.
                </li>
                <li>
                  Good experience in using various version controls like
                  Bitbucket, ClickUp, Jira, Azure DevOps and GIT.
                </li>
                <li>
                  Basic working experience in developing web projects using
                  Node.js and Express.js.
                </li>
                <li>Having knowledge of Next.js and gatsby.js.</li>
                <li>Deploy website using Netlify, Vercel and AWS.</li>
              </ul>
            </p>
            <p>
              <h5
                style={{
                  borderBottom: "1px solid #ffc107",
                  paddingBottom: "5px",
                  marginBottom: "5px",
                  width: "fit-content",
                }}
              >
                Professional Experience
              </h5>
            </p>
            <ul>
              <h6 style={{ marginBottom: "10px" }}>
                React and React Native developer at Bigscal Technologies Pvt.
                Ltd.
              </h6>
              <div
                style={{
                  color: "var(--color-text-2)",
                  background: "var(--color-text-3)",
                  padding: "5px 15px",
                  borderRadius: "15px",
                  boxShadow: "inset 0 3px 8px 0 var(--color-box-shadow-0)",
                  fontSize: "10px",
                  width: "fit-content",
                  marginBottom: "10px",
                }}
              >
                2022 – 2024 | Surat, India
              </div>
              <ul>
                <li>
                  Developed high-performance applications by leveraging
                  cutting-edge technologies including ReactJS, Redux, React
                  Hooks, React-Router, JavaScript, GraphQL, HTML5, CSS3, SASS,
                  and Bootstrap 4/5.
                </li>
                <li>Responsive design with flex, grid and media query, etc.</li>
                <li>
                  Developed a pixel-perfect UI from mockups and prototypes to
                  strengthen designs.
                </li>
                <li>
                  Developed custom API layer to handle all CRUD transactions,
                  JWT token management, and implemented interceptors to embed
                  custom headers.
                </li>
                <li>
                  Leveraged the full spectrum of React.js capabilities,
                  including component development, form handling, event
                  management, key management, routing, and advanced Redux and
                  Redux Toolkit (RTK) concepts.
                </li>
                <li>
                  Having worked on more then 5 project in which used many
                  libraries for fulfill requirements like Cytoscape.js, Apex
                  Chart, Grommet, Chakra UI, leaflet , formik, validation using
                  yup , material-UI, DevExtreme, react editor js, re-charts,
                  axios, Apollo GraphQL etc.
                </li>
                <li>Used Figma,and Adobe XD to collaborate with UX</li>
                <li>
                  Expertise usage of Github, Bit Bucket, Azure DevOps, Clickup
                  and JIRA as version control and tracking units.
                </li>
              </ul>
            </ul>

            {/* <blockquote>
              Let's embark on a journey to transform your ideas into impeccable
              web solutions. Reach out today, and together we'll create digital
              experiences that stand out in the crowd.
            </blockquote> */}

            <p>
              I enjoy being able to help people with advanced solutions to
              complex problems and pride myself in having clients that I have
              worked with and supported for over two years.
            </p>

            {/* <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}
